<button mat-menu-item
  (click)="inviteUsers()"
  data-cy="invite-users"
  class="invite-users-btn">
  <span translate="invite-users"></span>
</button>
<button mat-menu-item
  (click)="manageUsers()"
  data-cy="manage-users"
  class="manage-users-btn">
  <span translate="course-menu_manage-users"></span>
</button>
<button mat-menu-item
  (click)="editFolder()"
  data-cy="edit-course"
  class="edit-folder-btn">
  <span translate="course-menu_edit-course"></span>
</button>
<button mat-menu-item
  (click)="viewFolderReport()"
  data-cy="folder-report"
  class="view-folder-report-btn">
  <span translate="course-menu_view-folder-report"></span>
</button>
<button mat-menu-item
  (click)="duplicateFolder()"
  data-cy="duplicate-folder"
  class="duplicate-folder-btn">
  <span translate="course-menu_duplicate-folder"></span>
</button>
<button mat-menu-item
  (click)="archiveFolder()"
  data-cy="archive-folder"
  class="archive-folder-btn">
  <span translate="course-menu_archive-folder"></span>
</button>
@if (userService.currentUser.is_root_user) {
  <button mat-menu-item
    (click)="moveFolder()"
    data-cy="move-folder"
    class="move-folder-btn">
    <span translate="common_move-folder"></span>
  </button>
}
